/* eslint-disable arrow-body-style */
/* eslint-disable guard-for-in */
/* eslint-disable no-tabs */
/* eslint-disable space-before-blocks */
/* eslint-disable no-restricted-syntax */
/* eslint-disable spaced-comment */
/* eslint-disable react/jsx-indent */
/* eslint-disable indent */
import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import ReactTooltip from "react-tooltip";
import t from "../../../Common/utils/translation/translator";
import useCheckMobileScreen from "../../../Common/utils/useCheckMobileScreen";
import AxisFiltersRecapItem from "../Devices/AxisFiltersRecapItem";
import { selectPartnerPreferences } from "../../../Retrofit/store/slices/retrofit";
import ProductDataSheetLink from "../../../Common/components/Shared/ProductDataSheetLink";
import MsxIcons from "../../../Common/components/Icons/MsxIcons/MsxIcons";
import { selectConfigurationType, selectEventsData } from "../../../Common/store/slices/common";

const BOMTable = ({ tableData, tableHeader, tableTitle, axisId, commercializedProducts }) => {
  const isMobile = useCheckMobileScreen();
  const configurationType = useSelector(selectConfigurationType);

  const eventsData = useSelector(selectEventsData);

  const partnerPreferences = useSelector(selectPartnerPreferences);

  // eslint-disable-next-line camelcase
  const get_EAN_ENUMBER = (row) => {
    if (partnerPreferences && partnerPreferences?.preferredProductReference) {
      let preferredProductReference;
      if (partnerPreferences.preferredProductReference === "EAN") {
        preferredProductReference = "ean";
      } else if (partnerPreferences.preferredProductReference === "ENUMBER") {
        preferredProductReference = "e_num";
      }
      // eslint-disable-next-line max-len
      return row?.[preferredProductReference];
    }
    return null;
  };

  const tooltipNotCommercialized = t("msizer.ui.not_commercialized");

  const commercializedRefs = (product) => {
    return Object.keys(commercializedProducts?.commercializedProducts || {}).includes(product);
  };

  return (
    <>
      {tableTitle && (
        <span className="font-bold text-base text-ellipsis whitespace-nowrap overflow-hidden max-w-[250px]">
          {tableTitle}
        </span>
      )}
      {!isMobile && tableHeader && configurationType !== "INTEGRATED_DRIVES" && (
        <div className="flex justify-between text-xs">
          <AxisFiltersRecapItem
            axisId={axisId}
            filterName={t("msizer.ui.nominal_torque")}
            filterValue={tableHeader.nominalTorque}
            resultValue={tableHeader.nominalTorqueResult}
            unit={t("msizer.ui.unit.nm")}
          />

          <AxisFiltersRecapItem
            axisId={axisId}
            filterName={t("msizer.ui.nominal_speed")}
            filterValue={tableHeader.nominalSpeed}
            resultValue={tableHeader.nominalSpeedResult}
            unit={t("msizer.ui.unit.rpm")}
          />
          <AxisFiltersRecapItem
            axisId={axisId}
            filterName={t("msizer.ui.load_inertia")}
            filterValue={tableHeader.loadInertia}
            resultValue={tableHeader.loadInertiaResult}
            unit={t("msizer.ui.unit.kg_cm_squared")}
          />

          <AxisFiltersRecapItem
            axisId={axisId}
            filterName={t("msizer.ui.max_length")}
            filterValue={tableHeader.maxLength}
            resultValue={tableHeader.maxLengthResult}
            unit={t("msizer.ui.unit.mm")}
          />
        </div>
      )}
      <div className="text-xxs space-y-1">
        <div className="header-row px-2 flex bg-gray-100">
          <span className="flex-1 ">{t("msizer.ui.reference")}</span>
          <span className="flex-1 print:hidden">{t("msizer.ui.type")}</span>
          <span className="flex-1 ">{t("msizer.ui.description")}</span>
          <span className="flex-1  text-center">{t("msizer.ui.quantity")}</span>
        </div>

        {tableData?.map(
          (row, index) =>
            row.productReference && (
              // eslint-disable-next-line react/no-array-index-key
              <div key={index} className="px-2 flex pb-1">
                <div className="flex-1 flex flex-col">
                  <div className="text-secondary cursor-pointer flex items-center space-x-1">
                    <div className="underline font-bold">
                      <ProductDataSheetLink reference={row.productReference} eventTag={eventsData.tags.finalizeStep} />
                    </div>
                    <span className="">
                      {commercializedProducts?.commercializedProducts &&
                        commercializedRefs(row.productReference) === false && (
                          <>
                            <MsxIcons
                              data-tip
                              data-for={`countryScopeInfo-${row.productReference}`}
                              name="info"
                              size="nano"
                              className="text-orange-400 "
                            />
                            <ReactTooltip
                              id={`countryScopeInfo-${row.productReference}`}
                              type="light"
                              effect="solid"
                              backgroundColor="#FFFFFF"
                              textColor="rgb(31 41 55)"
                              className="hover:visible shadow-[0px_0px_8px_rgba(98,100,105,0.5)] rounded-[10px]"
                              multiline
                            >
                              <div className="space-x-1">
                                <MsxIcons name="info" size="nano" className="text-orange-400" />
                                <span className="text-orange-400 font-bold">
                                  {t("msizer.ui.not_commercialized.title")}
                                </span>
                              </div>
                              {tooltipNotCommercialized}
                            </ReactTooltip>
                          </>
                        )}
                    </span>
                  </div>
                  {get_EAN_ENUMBER(row) && (
                    <span>
                      ({partnerPreferences?.preferredProductReference}
                      {": "}
                      {get_EAN_ENUMBER(row)})
                    </span>
                  )}
                </div>
                <span className="flex-1 print:hidden">{t(`msizer.ui.${row.type.toLowerCase()}`)}</span>
                <span className="flex-1 capitalize break-all">{row.description}</span>
                <span className="flex-1  text-center">{row.quantity}</span>
              </div>
            )
        )}
      </div>
    </>
  );
};

BOMTable.propTypes = {
  tableData: PropTypes.arrayOf(PropTypes.object),
  // eslint-disable-next-line react/forbid-prop-types
  tableHeader: PropTypes.object,
  tableTitle: PropTypes.string,
  axisId: PropTypes.string,
  commercializedProducts: PropTypes.array
};

BOMTable.defaultProps = {
  tableData: [],
  tableHeader: null,
  tableTitle: "",
  axisId: "",
  commercializedProducts: []
};

export default BOMTable;
